import { Wrench, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui';

export function MaintenancePage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-warning-50 to-warning-100 p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="space-y-4">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-warning/10">
            <Wrench className="h-8 w-8 text-warning animate-pulse" />
          </div>
          <CardTitle className="text-2xl">{t('maintenance.title')}</CardTitle>
          <CardDescription className="text-base">{t('maintenance.description')}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Clock className="h-4 w-4" />
            <span>{t('maintenance.estimatedTime', { time: 'Soon' })}</span>
          </div>
          <div className="pt-4">
            <p className="text-xs text-muted-foreground">{t('maintenance.contactSupport')}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
